import type { Stripe } from '@stripe/stripe-js';

let stripePromise: Promise<Stripe | null> | null = null;

export const getStripe = () => {
  if (!stripePromise) {
    stripePromise = import('@stripe/stripe-js').then(({ loadStripe }) =>
      loadStripe(process.env.STRIPE_PUBLISHABLE_KEY ?? '', {
        developerTools: { assistant: { enabled: false } }
      })
    );
  }

  return stripePromise;
};
